import { translate } from 'src/app/project/features/translate/translate';
import { ISelectMultipleOptionStatus } from 'src/app/project/components/input/select-multiple/select-multiple.model';
import { EStatus } from 'src/app/project/shared/enums/status.enum';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { EPointSearchOperator } from 'src/app/project/modules/points/point-search/point-search.consts';

export function getAdvancedStatusValues(): ISelectMultipleOptionStatus[] {
  return [
    {
      value: EStatus.OPEN,
      label: translate('open'),
      operator: EPointSearchOperator.IN,
      selected: false,
      iconSrc: EIconPath.ICON_BADGE_STATUS_OPEN_14,
    },
    {
      value: EStatus.IN_PROGRESS,
      label: translate('in_progress'),
      selected: false,
      operator: EPointSearchOperator.IN,
      iconSrc: EIconPath.ICON_BADGE_STATUS_IN_PROGRESS_14,
    },
    {
      value: EStatus.TO_REVIEW,
      label: translate('to_review'),
      selected: false,
      operator: EPointSearchOperator.IN,
      iconSrc: EIconPath.ICON_BADGE_STATUS_TO_REVIEW_14,
    },
    {
      value: EStatus.ONHOLD,
      label: translate('on_hold'),
      selected: false,
      operator: EPointSearchOperator.IN,
      iconSrc: EIconPath.ICON_BADGE_STATUS_ON_HOLD_14,
    },
    {
      value: EStatus.CLOSED,
      label: translate('completed'),
      selected: false,
      operator: EPointSearchOperator.IN,
      iconSrc: EIconPath.ICON_BADGE_STATUS_CLOSED_14,
    },
    {
      value: EStatus.CANCELED,
      label: translate('canceled'),
      selected: false,
      operator: EPointSearchOperator.IN,
      iconSrc: EIconPath.ICON_BADGE_STATUS_CANCELED_14,
    },
  ];
}
